import dayjs from 'dayjs';
import _groupBy from 'lodash/groupBy';
import { mapState } from 'vuex';
import OrderCard from '@/components/OrderCard/OrderCard.vue';
import QrCodeDialog from '@/components/QrCodeDialog/QrCodeDialog.vue';
import { GROUP_BUYING_STATUS, MENU_LIST_ITEM_STATUSES, RECEIVE_STATUS } from '@/utils/constants';
import { getWeekString } from '@/utils/helper';

export default {
  name: 'MenuListItem',
  components: {
    OrderCard,
    QrCodeDialog,
  },
  props: {
    items: {
      default: () => [],
      type: Array,
    },
  },
  data() {
    return {
      showQrCodeDialog: false,
      qrCodeOrders: [],
    };
  },
  computed: {
    ...mapState('user', {
      user: ({ user }) => user,
    }),
    GROUP_BUYING_STATUS() {
      return GROUP_BUYING_STATUS;
    },
    isScheduled() {
      return this.item?.status === MENU_LIST_ITEM_STATUSES.SCHEDULED;
    },
    orderGroups() {
      const results = {};
      const groups = _groupBy(this.items, ({ receive_times: receiveTimes = [] }) => dayjs(receiveTimes[0]?.start_time || '').format('YYYY-MM-DD'));
      Object.keys(groups).sort((a, b) => new Date(a) - new Date(b)).forEach((groupKey) => {
        results[groupKey] = groups[groupKey];
      });
      return results;
    },
    showReceiveCode() {
      return this.user?.enablePickupCode || false;
    },
    unReceiveOrders() {
      const result = {};
      const now = dayjs();
      this.items.forEach(({ id, member_orders: memberOrders = [] }) => {
        result[id] = memberOrders
          .filter(({ status, receive_time: { end_time: end, start_time: start } }) => dayjs(end).isSameOrAfter(now, 'day') && dayjs(start).isSameOrBefore(now, 'day') && status === RECEIVE_STATUS.UNRECEIVED);
      });
      return result;
    },
  },
  methods: {
    getBorderColor({ joined = false, status }) {
      if (status === GROUP_BUYING_STATUS.SCHEDULED) {
        return 'border-l-gray-500';
      }
      return joined ? 'border-l-primary-400' : 'border-l-orange-500';
    },
    getHeaderButtonClass({ joined = false, status }) {
      if (status === GROUP_BUYING_STATUS.SCHEDULED) {
        return 'scheduled';
      }
      return joined ? 'joined' : 'un-joined';
    },
    getHeaderButtonText({ joined = false, status }) {
      if (status === GROUP_BUYING_STATUS.SCHEDULED) {
        return '查看菜單';
      }
      return joined ? '加點品項' : '前往點餐';
    },
    inValidReceiveTime({ id }) {
      return this.unReceiveOrders[id]?.length;
    },
    receiveData(receiveTime = '') {
      return receiveTime ? dayjs(receiveTime).format('MM/DD') : '';
    },
    receiveWeek(receiveTime = '') {
      return receiveTime ? getWeekString(receiveTime) : '';
    },
    onShowQrCodeClick({ id }) {
      this.qrCodeOrders = this.unReceiveOrders[id] || [];
      this.showQrCodeDialog = true;
    },
  },
};
